import { defineStore } from 'pinia'
import { DexPoolsV2Service } from '@/services/dex-pools-v2-service'
import { useRequestFactory } from './factories/requestFactory'
import type {
  DexScreenerPoolItem,
  GeckoTerminalPoolItem,
  DexPoolChain,
} from '@/services/dex-pools-v2-service/types'

// export const useEyeDexStore = defineStore('eye-dex', {
//   state: () => ({
//     loading: {} as Record<string, boolean>,
//     error: {} as Record<string, ApiError | null>,
//   }),

//   getters: {},

//   actions: {
//     async fetchPool(actionId: string, address: string, cex: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchPool(address, cex)
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchContract(actionId: string, asset: string, cex: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchContract(asset, cex)
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchAssetPool(actionId: string, pool: string, chainId: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchAssetPoolByAddress(pool, chainId)
//         delete this.error[actionId]
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchTicks(actionId: string, ctr: string, pool: string, chain: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchTicks(ctr, pool, chain)
//         delete this.error[actionId]
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchGmgnTicks(actionId: string, ctr: string, chain: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchGmgnTicks(ctr, chain)
//         delete this.error[actionId]
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchPrice(actionId: string, address: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchPrice(address)
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//     async fetchOhlcv(actionId: string, chain: string, address: string) {
//       this.loading[actionId] = true
//       try {
//         const req = await DexPoolsV2Service.fetchOhlcv(chain, address)
//         return req.data
//       } catch (thrown) {
//         if (axios.isAxiosError(thrown) && thrown.response) {
//           this.error[actionId] = {
//             message: thrown.response?.data,
//             code: thrown.response?.status,
//           }
//         } else {
//           this.error[actionId] = FALLBACK_API_ERROR
//         }
//       } finally {
//         this.loading[actionId] = false
//       }
//     },
//   },
// })

export const useEyeDexStore = defineStore('eye-dex', () => {
  const { loading, errors, requestHandler } = useRequestFactory<string>()

  const fetchPool = async (actionId: string, address: string, cex: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchPool(address, cex)
      return req.data
    })
  }
  const fetchContract = async (actionId: string, asset: string, cex: string, marketType: string = 'swap') => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchContract(asset, cex, marketType)
      return req.data
    })
  }
  const fetchAssetPool = async (actionId: string, pool: string, chainId: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchAssetPoolByAddress(pool, chainId)
      return req.data
    })
  }
  const fetchTicks = async (actionId: string, ctr: string, pool: string, chain: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchTicks(ctr, pool, chain)
      return req.data
    })
  }
  const fetchGmgnTicks = async (actionId: string, ctr: string, chain: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchGmgnTicks(ctr, chain)
      return req.data
    })
  }
  const fetchPrice = async (actionId: string, address: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchPrice(address)
      return req.data
    })
  }
  const fetchOhlcv = async (actionId: string, chain: string, address: string) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchOhlcv(chain, address)
      return req.data
    })
  }
  const fetchDexScreenerPools = async (
    actionId: string,
    chainId: DexPoolChain,
    contractAddress: string,
  ): Promise<DexScreenerPoolItem[] | undefined> => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchDexScreenerPools(chainId, contractAddress)
      return req.data
    })
  }
  const fetchGeckoTerminalPools = async (
    actionId: string,
    chainId: DexPoolChain,
    contractAddress: string,
  ): Promise<GeckoTerminalPoolItem[] | undefined> => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.fetchGeckoTerminalPools(chainId, contractAddress)
      return req.data
    })
  }
  const putTokenAddress = async (
    actionId: string,
    exchange: string,
    asset: string,
    chain: string,
    ctr: string,
    marketType: string = 'swap',
  ) => {
    return await requestHandler(actionId, async () => {
      const req = await DexPoolsV2Service.putTokenAddress(exchange, asset, chain, ctr, marketType)
      return req.data
    })
  }

  return {
    loading,
    errors,
    fetchTicks,
    fetchPool,
    fetchContract,
    fetchAssetPool,
    putTokenAddress,
    fetchGmgnTicks,
    fetchPrice,
    fetchOhlcv,
    fetchDexScreenerPools,
    fetchGeckoTerminalPools,
  }
})
